module.exports = __webpack_public_path__ + "img/head-icon_.1af640ed.png";